import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import TablePaginationCustom from "@saleor/components/TablePaginationCustom";
import { AlternatedMaterialsQuery } from "@saleor/graphql";
import { renderCollection } from "@saleor/misc";
import { ListProps, RelayToFlat } from "@saleor/types";
import cls from "classnames";
import moment from "moment";
import React, { useRef } from "react";
import { FormattedNumber, useIntl } from "react-intl";

import StickyHorizontalScrollBar from "../../../components/StickyHorizontalScrollBar";
import TableCellHeader from "../../../components/TableCellHeader";
import useStyles from "./styles";

interface TableListAttentionProps extends ListProps {
  dataLogChange: RelayToFlat<AlternatedMaterialsQuery["alternatedMaterials"]>;
  listFilter: any[];
  totalCount: number | null;
  latestPageItemNumber: number | null;
  onPreviousFirstPage: () => void;
  onNextLastPage: () => void;
}

const TableListLogChange: React.FC<TableListAttentionProps> = props => {
  const {
    dataLogChange,
    listFilter,
    disabled,
    settings,
    pageInfo,
    totalCount,
    latestPageItemNumber,
    onPreviousPage,
    onNextPage,
    onUpdateListSettings,
    onNextLastPage,
    onPreviousFirstPage
  } = props;

  const intl = useIntl();
  const classes = useStyles();
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      {dataLogChange.length && listFilter.length ? (
        <>
          <MyTypography variant="h7" className={classes.titleTable}>
            {intl.formatMessage({ defaultMessage: "รายการที่เกี่ยวข้อง" })}
          </MyTypography>
          <div className={classes.root} ref={containerRef}>
            <Table>
              <TableHead>
                <TableRow className={classes.rowCellBorder}>
                  <TableCellHeader
                    rowSpan={2}
                    className={cls(classes.cellFirst, classes.col_1)}
                  >
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "S/O No." })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_2}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "Item No." })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_3}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({
                        defaultMessage: "Sale Organization"
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_4}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "Sold to" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_name}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "Customer Name" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_5}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({
                        defaultMessage: "รหัสสินค้าที่สั่ง"
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_6}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "จำนวนที่สั่ง" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader textAlign={"center"} colSpan={4}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "จำนวนที่สั่ง" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_11}>
                    <div className={classes.rowFlex}>
                      <MyTypography
                        variant={"subtitle3"}
                        className={classes.cellHeader}
                      >
                        {intl.formatMessage({ defaultMessage: "ชื่อไฟล์" })}
                      </MyTypography>{" "}
                      <MyTypography
                        variant={"body3"}
                        className={classes.cellHeader}
                      >
                        (สำหรับ PO Upload)
                      </MyTypography>
                    </div>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_12}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "PO No." })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_13}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({
                        defaultMessage: "Item Request Date"
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_14}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "Create Date" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_15}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "Create by" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_16}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({
                        defaultMessage: "Last Update Date"
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader rowSpan={2} className={classes.col_17}>
                    <MyTypography
                      variant={"subtitle3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "Last Update by" })}
                    </MyTypography>
                  </TableCellHeader>
                </TableRow>
                <TableRow>
                  <TableCellHeader className={classes.col_7}>
                    <MyTypography
                      variant={"body3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({
                        defaultMessage: "รหัสสินค้าทดแทน"
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader className={classes.col_8}>
                    <MyTypography
                      variant={"body3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({
                        defaultMessage: "จำนวนม้วนที่เปลี่ยน"
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader className={classes.col_9}>
                    <div className={classes.rowFlex}>
                      <MyTypography
                        variant={"body3"}
                        className={classes.cellHeader}
                      >
                        {intl.formatMessage({
                          defaultMessage: "จำนวนที่เปลี่ยน"
                        })}
                      </MyTypography>{" "}
                      <MyTypography
                        variant={"body3"}
                        className={classes.cellTon}
                      >
                        {intl.formatMessage({ defaultMessage: "(Ton)" })}
                      </MyTypography>
                    </div>
                  </TableCellHeader>
                  <TableCellHeader className={classes.col_10}>
                    <MyTypography
                      variant={"body3"}
                      className={classes.cellHeader}
                    >
                      {intl.formatMessage({ defaultMessage: "Plant" })}
                    </MyTypography>
                  </TableCellHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {renderCollection(dataLogChange, item => (
                  <TableRow key={item.id} className={classes.rowCellBorder}>
                    <TableCell className={classes.cellFirst}>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.order.soNo}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.itemNo}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.order?.saleOrganization
                          ? `${item.orderLine.order.saleOrganization.code} - ${item.orderLine.order.saleOrganization.name}`
                          : ""}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.order?.soldTo
                          ? `${item.orderLine.order.soldTo?.code} - ${item.orderLine.order.soldTo?.name}`
                          : ""}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item.orderLine.order.soldTo?.name}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.oldProduct.code}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        <FormattedNumber value={item?.orderLine?.quantity} />
                      </MyTypography>
                    </TableCell>
                    <TableCell className={classes.cellNoBorder}>
                      <MyTypography
                        style={{
                          color: item?.errorType ? " #E41B17" : null
                        }}
                        variant={"body3"}
                      >
                        {item?.errorType || item?.newProduct?.code}
                      </MyTypography>
                    </TableCell>
                    <TableCell className={classes.cellNoBorder}>
                      <MyTypography variant={"body3"}>
                        {item?.quantityChangeOfRoll ? (
                          <FormattedNumber value={item?.quantityChangeOfRoll} />
                        ) : null}
                      </MyTypography>
                    </TableCell>
                    <TableCell className={classes.cellNoBorder}>
                      <MyTypography variant={"body3"}>
                        {item?.quantityChangeOfTon ? (
                          <FormattedNumber value={item?.quantityChangeOfTon} />
                        ) : null}
                      </MyTypography>
                    </TableCell>
                    <TableCell className={classes.cellNoBorder}>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.plant}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item.orderLine.order.poUploadFileName
                          ? `${item.orderLine.order.poUploadFileName}`
                          : ""}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.order?.poNumber}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.requestDate
                          ? moment(item?.orderLine?.requestDate).format(
                              "DD/MM/YYYY"
                            )
                          : ""}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.order?.createdAt
                          ? moment(item?.orderLine?.order?.createdAt).format(
                              "DD/MM/YYYY"
                            )
                          : ""}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.order?.createdBy
                          ? `${item?.orderLine?.order?.createdBy?.firstName} ${item?.orderLine?.order?.createdBy?.lastName}`
                          : ""}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.order?.updatedAt
                          ? moment(item?.orderLine?.order?.updatedAt).format(
                              "DD/MM/YYYY"
                            )
                          : ""}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item?.orderLine?.order?.updateBy
                          ? `${item?.orderLine?.order?.updateBy?.firstName} ${item?.orderLine?.order?.updateBy?.lastName}`
                          : ""}
                      </MyTypography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {dataLogChange.length ? (
              <StickyHorizontalScrollBar container={containerRef} bottom={90} />
            ) : (
              ""
            )}
          </div>
          <Box className={classes.paginateFooter}>
            <TablePaginationCustom
              settings={settings}
              hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
              hasPreviousPage={
                pageInfo && !disabled ? pageInfo.hasPreviousPage : false
              }
              onNextPage={onNextPage}
              onPreviousPage={onPreviousPage}
              onPreviousFirstPage={onPreviousFirstPage}
              onNextLastPage={onNextLastPage}
              onUpdateListSettings={onUpdateListSettings}
              latestPageItemNumber={latestPageItemNumber}
              totalCount={totalCount}
              isBackFistPage
              isNextLastPage
              isShowIndex
              disabled={disabled}
            />
          </Box>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default TableListLogChange;
